import { AudioManager } from '../../core/AudioManager';
import { AudioHandle } from '../../core/AudioManager.types';

export class AmbientAudio {
    static readonly PRELOAD = ['../assets/sounds/ambient_outdoor.wav'] as const;
    private static readonly SRC = AmbientAudio.PRELOAD[0];

    private handle: AudioHandle | null = null;

    constructor(private readonly audioManager: AudioManager) {}

    public play(): void {
        if (this.handle) { return; }
        this.handle = this.audioManager.playMusic(AmbientAudio.SRC, 0.4, true);
    }

    public stop(): void {
        if (!this.handle) { return; }
        this.audioManager.stopMusic(this.handle);
        this.handle = null;
    }
}
